<template>
  <footer class="main-footer">
    <div class="footer-left">
      <img src="static/img/lswork.png" alt="lswork" width="40">
      Powered by <a href="https://clorisconsultant.com/" target="_blank">Cloris Cheung Consultant Company</a> © 2026
      <div class="bullet"></div>
      
      &nbsp;All rights reserved.
      <label> {{ systemVersion }}</label>
    </div>
    <div class="footer-right">
      <label style="padding-right:15px">Page Code : {{ access_code }}</label>
    </div>
  </footer>
</template>

<script>
import config from "@/config.js";

export default {
  name: "myfooter",
  data() {
    return {
      systemVersion: config.systemVersion
    };
  },
  computed: {
    access_code() {
      return this.$route.meta.access_code;
    }
  }
};
</script>